@if (loginService.IsLoggedIn()) {
  <div>
    you are logged in as {{loginService.LoggedInName()}}
    <button class="button is-small is-primary" (click)="Logout()">log out</button>
  </div>
}
@if (!loginService.IsLoggedIn()) {
  <div>
    you are not logged in
  </div>
}
